import React from 'react';
import { Typography } from 'antd';

const { Text, Title } = Typography;

export const SummaryEmptyState = () => (
    <div className="summary-wrapper-no-data-snippet">
        <Title className="summary-wrapper-no-data-title" level={2}>
            Discover your environment. Simplify your migration.
        </Title>
        <Text className="summary-wrapper-no-data-text">
            Import your RV Tools data to uncover performance insights, identify optimization opportunities, and prepare
            for a smooth migration. Once processed, your environment details and metrics will appear in the dashboard
            below.
        </Text>
    </div>
);
